import { atob, btoa } from './atob';
import { Blob } from './blob';
import devicePixelRatio from './devicePixelRatio';
import { $document } from './document';
import { Element } from './Element';
import { Event } from './Event';
import EventTarget from './EventTarget';
import { HTMLCanvasElement } from './HTMLCanvasElement';
import { HTMLElement } from './HTMLElement';
import { HTMLMediaElement } from './HTMLMediaElement';
import { HTMLVideoElement } from './HTMLVideoElement';
import { Image } from './Image';
import { ImageData } from './ImageData';
import { $location as $location2 } from './location';
import { navigator } from './navigator';
import { Node } from './Node';
import { performance } from './performance';
import { cancelAnimationFrame, requestAnimationFrame } from './requestAnimationFrame';
import { screen } from './screen';
import { URL } from './url';
import { WebGLRenderingContext } from './WebGL';
import { WebGL2RenderingContext } from './WebGL2';
import { $XMLHttpRequest as $XMLHttpRequest2 } from './XMLHttpRequest';
import { globalWindow } from './global';
export var isMiniAli = typeof my !== 'undefined' && !!my && typeof my.showToast === 'function' && my.isFRM !== true;
export var isWeChatMiniProgram = typeof wx !== 'undefined' && wx !== null && (typeof wx.request !== 'undefined' || typeof wx.miniProgram !== 'undefined');
export var isMini = isMiniAli || isWeChatMiniProgram;
export var miniWindow = {
  atob: atob,
  btoa: btoa,
  devicePixelRatio: devicePixelRatio,
  Blob: Blob,
  document: $document,
  Element: Element,
  Event: Event,
  EventTarget: EventTarget,
  HTMLCanvasElement: HTMLCanvasElement,
  HTMLElement: HTMLElement,
  HTMLMediaElement: HTMLMediaElement,
  HTMLVideoElement: HTMLVideoElement,
  Image: Image,
  ImageData: ImageData,
  navigator: navigator,
  Node: Node,
  requestAnimationFrame: requestAnimationFrame,
  cancelAnimationFrame: cancelAnimationFrame,
  screen: screen,
  XMLHttpRequest: $XMLHttpRequest2,
  performance: performance,
  URL: URL,
  WebGLRenderingContext: WebGLRenderingContext,
  WebGL2RenderingContext: WebGL2RenderingContext,
  addEventListener: function addEventListener(type, listener) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    $document.addEventListener(type, listener, options);
  },
  removeEventListener: function removeEventListener(type, listener, options) {
    $document.removeEventListener(type, listener);
  },
  dispatchEvent: function dispatchEvent(event) {
    $document.dispatchEvent(event);
  },
  innerWidth: screen.availWidth,
  innerHeight: screen.availHeight,
  setTimeout: setTimeout,
  clearTimeout: clearTimeout,
  setInterval: setInterval,
  clearInterval: clearInterval
};
export var $window = isMini ? miniWindow : globalWindow;
export var $XMLHttpRequest = isMini ? $XMLHttpRequest2 : globalWindow.XMLHttpRequest;
export var $location = isMini ? $location2 : globalWindow.location;
export * from './EventIniter/index';
//# sourceMappingURL=index.js.map